//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {getAccessTokenFromLocalStorage} from '../utilities/platform-helpers/auth-helper';
export class BaseClient {
  public async transformOptions(options: RequestInit): Promise<RequestInit> {
    const token = localStorage.getItem('token');
    const headerData = token
      ? {
          ...options.headers,
          Authorization: 'Bearer ' + token,
          TimezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
      : {
          ...options.headers,
        };
    return Object.assign({}, options, {
      headers: headerData,
    });
  }
}

export class DeviceCategoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    get(): Promise<DeviceCategory[]> {
        let url_ = this.baseUrl + "/api/DeviceCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<DeviceCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceCategory[]>(null as any);
    }

    post(deviceCategory: DeviceCategory): Promise<DeviceCategory> {
        let url_ = this.baseUrl + "/api/DeviceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceCategory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<DeviceCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceCategory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceCategory>(null as any);
    }

    delete(deviceCategory: DeviceCategory): Promise<void> {
        let url_ = this.baseUrl + "/api/DeviceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceCategory);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    insert(deviceConfigDTO: DeviceConfigDTO): Promise<DeviceConfigDTO> {
        let url_ = this.baseUrl + "/api/DeviceConfig/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceConfigDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<DeviceConfigDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceConfigDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceConfigDTO>(null as any);
    }

    update(deviceConfigDTO: DeviceConfigDTO): Promise<DeviceConfigDTO> {
        let url_ = this.baseUrl + "/api/DeviceConfig/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceConfigDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<DeviceConfigDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceConfigDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceConfigDTO>(null as any);
    }
}

export class DeviceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    getByOrganization(organizationId: number | undefined): Promise<Device[]> {
        let url_ = this.baseUrl + "/api/Device/GetByOrganization?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByOrganization(_response);
        });
    }

    protected processGetByOrganization(response: Response): Promise<Device[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Device.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device[]>(null as any);
    }

    getDevicesFull(organizationId: number | undefined): Promise<DeviceInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Device/GetDevicesFull?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDevicesFull(_response);
        });
    }

    protected processGetDevicesFull(response: Response): Promise<DeviceInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceInfoDTO[]>(null as any);
    }

    getByConnectId(connectId: string | null | undefined, forSetup: boolean | undefined): Promise<DeviceInfoDTO> {
        let url_ = this.baseUrl + "/api/Device/GetByConnectId?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        if (forSetup === null)
            throw new Error("The parameter 'forSetup' cannot be null.");
        else if (forSetup !== undefined)
            url_ += "forSetup=" + encodeURIComponent("" + forSetup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByConnectId(_response);
        });
    }

    protected processGetByConnectId(response: Response): Promise<DeviceInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceInfoDTO>(null as any);
    }

    configureDevice(deviceDTO: DeviceInfoDTO): Promise<DeviceInfoDTO> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfigureDevice(_response);
        });
    }

    protected processConfigureDevice(response: Response): Promise<DeviceInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceInfoDTO>(null as any);
    }

    removeConfiguration(deviceId: number | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/Device/RemoveConfiguration?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveConfiguration(_response);
        });
    }

    protected processRemoveConfiguration(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    updateFirmware(connectId: string | null | undefined, firmwareVersion: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/UpdateFirmware?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        if (firmwareVersion !== undefined && firmwareVersion !== null)
            url_ += "firmwareVersion=" + encodeURIComponent("" + firmwareVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFirmware(_response);
        });
    }

    protected processUpdateFirmware(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDeviceTwinState(connectId: string | null | undefined): Promise<DeviceTwinStateDTO> {
        let url_ = this.baseUrl + "/api/Device/GetDeviceTwinState?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceTwinState(_response);
        });
    }

    protected processGetDeviceTwinState(response: Response): Promise<DeviceTwinStateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceTwinStateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceTwinStateDTO>(null as any);
    }
}

export class DeviceDebuggingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    toggleDebugLogging(connectId: string | null | undefined, enableLogging: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DeviceDebugging/ToggleDebugLogging?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        if (enableLogging === null)
            throw new Error("The parameter 'enableLogging' cannot be null.");
        else if (enableLogging !== undefined)
            url_ += "enableLogging=" + encodeURIComponent("" + enableLogging) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToggleDebugLogging(_response);
        });
    }

    protected processToggleDebugLogging(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDeviceDebugLog(connectId: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DeviceDebugging/GetDeviceDebugLog?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceDebugLog(_response);
        });
    }

    protected processGetDeviceDebugLog(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    requestDataDump(connectId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DeviceDebugging/RequestDataDump?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestDataDump(_response);
        });
    }

    protected processRequestDataDump(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDataDumpData(databaseId: number | undefined, from: Date | undefined): Promise<DeviceDataDumpDTO> {
        let url_ = this.baseUrl + "/api/DeviceDebugging/GetDataDumpData?";
        if (databaseId === null)
            throw new Error("The parameter 'databaseId' cannot be null.");
        else if (databaseId !== undefined)
            url_ += "databaseId=" + encodeURIComponent("" + databaseId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDataDumpData(_response);
        });
    }

    protected processGetDataDumpData(response: Response): Promise<DeviceDataDumpDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceDataDumpDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceDataDumpDTO>(null as any);
    }
}

export class DeviceModelClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    getByCategory(categoryId: number | undefined): Promise<DeviceModel[]> {
        let url_ = this.baseUrl + "/api/DeviceModel/GetByCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCategory(_response);
        });
    }

    protected processGetByCategory(response: Response): Promise<DeviceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceModel[]>(null as any);
    }

    post(deviceModel: DeviceModel): Promise<DeviceModel> {
        let url_ = this.baseUrl + "/api/DeviceModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<DeviceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceModel>(null as any);
    }

    delete(deviceModel: DeviceModel): Promise<void> {
        let url_ = this.baseUrl + "/api/DeviceModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceModel);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FirmwareClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    getNewOrEqualFirmwaresForDevice(connectId: string | null | undefined): Promise<Firmware[]> {
        let url_ = this.baseUrl + "/api/Firmware/GetNewOrEqualFirmwaresForDevice?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNewOrEqualFirmwaresForDevice(_response);
        });
    }

    protected processGetNewOrEqualFirmwaresForDevice(response: Response): Promise<Firmware[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Firmware.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firmware[]>(null as any);
    }

    getAll(): Promise<Firmware[]> {
        let url_ = this.baseUrl + "/api/Firmware/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Firmware[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Firmware.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firmware[]>(null as any);
    }

    getDeviceFirmwareVersion(connectId: string | null | undefined): Promise<DeviceFirmwareDTO> {
        let url_ = this.baseUrl + "/api/Firmware/GetDeviceFirmwareVersion?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceFirmwareVersion(_response);
        });
    }

    protected processGetDeviceFirmwareVersion(response: Response): Promise<DeviceFirmwareDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceFirmwareDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceFirmwareDTO>(null as any);
    }

    getFWUpdateTimestamp(connectId: string | null | undefined): Promise<Date | null> {
        let url_ = this.baseUrl + "/api/Firmware/GetFWUpdateTimestamp?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFWUpdateTimestamp(_response);
        });
    }

    protected processGetFWUpdateTimestamp(response: Response): Promise<Date | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date | null>(null as any);
    }

    downloadBackupFirmware(connectId: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Firmware/DownloadBackupFirmware?";
        if (connectId !== undefined && connectId !== null)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadBackupFirmware(_response);
        });
    }

    protected processDownloadBackupFirmware(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class LocationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    get(): Promise<LocationDTO[]> {
        let url_ = this.baseUrl + "/api/Location";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LocationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDTO[]>(null as any);
    }

    getByOrganizationId(organizationId: number | undefined): Promise<LocationDTO[]> {
        let url_ = this.baseUrl + "/api/Location/GetByOrganizationId?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByOrganizationId(_response);
        });
    }

    protected processGetByOrganizationId(response: Response): Promise<LocationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDTO[]>(null as any);
    }

    insert(locationDTO: LocationDTO): Promise<LocationDTO> {
        let url_ = this.baseUrl + "/api/Location/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<LocationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDTO>(null as any);
    }

    update(locationDTO: LocationDTO): Promise<LocationDTO> {
        let url_ = this.baseUrl + "/api/Location/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<LocationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDTO>(null as any);
    }

    delete(locationDTO: LocationDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Location/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllLocationsApiKey(organizationId: number | undefined): Promise<Location[]> {
        let url_ = this.baseUrl + "/api/Location/GetAllLocationsApiKey?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllLocationsApiKey(_response);
        });
    }

    protected processGetAllLocationsApiKey(response: Response): Promise<Location[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Location.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location[]>(null as any);
    }
}

export class NotificationHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    post(notificationHistory: NotificationHistory): Promise<NotificationHistory> {
        let url_ = this.baseUrl + "/api/NotificationHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationHistory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<NotificationHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationHistory>(null as any);
    }
}

export class NotificationSubscriptionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    get(): Promise<NotificationSubscription[]> {
        let url_ = this.baseUrl + "/api/NotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationSubscription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSubscription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscription[]>(null as any);
    }

    getFromOrganization(organizationId: number | undefined): Promise<NotificationSubscriptionDTO[]> {
        let url_ = this.baseUrl + "/api/NotificationSubscription/GetFromOrganization?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFromOrganization(_response);
        });
    }

    protected processGetFromOrganization(response: Response): Promise<NotificationSubscriptionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSubscriptionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscriptionDTO[]>(null as any);
    }

    update(notificationSubscriptionDTO: NotificationSubscriptionDTO): Promise<NotificationSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/NotificationSubscription/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationSubscriptionDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<NotificationSubscriptionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSubscriptionDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSubscriptionDTO>(null as any);
    }
}

export class OrganizationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    get(): Promise<Organization[]> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    post(organization: Organization): Promise<Organization> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Organization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization>(null as any);
    }

    put(organization: Organization): Promise<Organization> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Organization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization>(null as any);
    }

    delete(organization: Organization): Promise<void> {
        let url_ = this.baseUrl + "/api/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAll(): Promise<Organization[]> {
        let url_ = this.baseUrl + "/api/Organization/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    getById(id: number | undefined): Promise<Organization> {
        let url_ = this.baseUrl + "/api/Organization/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Organization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization>(null as any);
    }

    newOrganizationRequest(organizationName: string | null | undefined, email: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organization/NewOrganizationRequest?";
        if (organizationName !== undefined && organizationName !== null)
            url_ += "organizationName=" + encodeURIComponent("" + organizationName) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNewOrganizationRequest(_response);
        });
    }

    protected processNewOrganizationRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    getReport(locationId: number | undefined, fromDate: Date | undefined, toDate: Date | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Report/GetReport?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCompleteReport(fromDate: Date | undefined, toDate: Date | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Report/GetCompleteReport?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompleteReport(_response);
        });
    }

    protected processGetCompleteReport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getReportsApiKey(locationIds: number[], fromDate: Date | undefined, toDate: Date | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Report/GetReportsApiKey?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportsApiKey(_response);
        });
    }

    protected processGetReportsApiKey(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class SecureDeviceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    getByConnectId(connectId: string | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/SecureDevice/GetByConnectId?";
        if (connectId === null)
            throw new Error("The parameter 'connectId' cannot be null.");
        else if (connectId !== undefined)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByConnectId(_response);
        });
    }

    protected processGetByConnectId(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    getById(id: number | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/SecureDevice/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    createUnconfigured(connectId: string | undefined): Promise<Device> {
        let url_ = this.baseUrl + "/api/SecureDevice/CreateUnconfigured?";
        if (connectId === null)
            throw new Error("The parameter 'connectId' cannot be null.");
        else if (connectId !== undefined)
            url_ += "connectId=" + encodeURIComponent("" + connectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUnconfigured(_response);
        });
    }

    protected processCreateUnconfigured(response: Response): Promise<Device> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Device>(null as any);
    }

    uploadFirmware(file: FileParameter | undefined, firmwareVersion: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SecureDevice/UploadFirmware?";
        if (firmwareVersion === null)
            throw new Error("The parameter 'firmwareVersion' cannot be null.");
        else if (firmwareVersion !== undefined)
            url_ += "firmwareVersion=" + encodeURIComponent("" + firmwareVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadFirmware(_response);
        });
    }

    protected processUploadFirmware(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDeviceIdsToReboot(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/SecureDevice/GetDeviceIdsToReboot";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceIdsToReboot(_response);
        });
    }

    protected processGetDeviceIdsToReboot(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class TimeZoneClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    get(): Promise<TimeZoneDTO[]> {
        let url_ = this.baseUrl + "/api/TimeZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TimeZoneDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeZoneDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZoneDTO[]>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:64612";
    }

    getById(id: number | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/User/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    getByOrganizationId(organizationId: number | undefined): Promise<User[]> {
        let url_ = this.baseUrl + "/api/User/GetByOrganizationId?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByOrganizationId(_response);
        });
    }

    protected processGetByOrganizationId(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(null as any);
    }

    getWithSubscription(organizationId: number | undefined): Promise<User[]> {
        let url_ = this.baseUrl + "/api/User/GetWithSubscription?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithSubscription(_response);
        });
    }

    protected processGetWithSubscription(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(null as any);
    }

    getWithSubscriptionApiKey(organizationId: number | undefined): Promise<User[]> {
        let url_ = this.baseUrl + "/api/User/GetWithSubscriptionApiKey?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithSubscriptionApiKey(_response);
        });
    }

    protected processGetWithSubscriptionApiKey(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(null as any);
    }

    getByAuthId(): Promise<User> {
        let url_ = this.baseUrl + "/api/User/GetByAuthId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByAuthId(_response);
        });
    }

    protected processGetByAuthId(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    getOrganizationJob(userId: number | undefined, organizationId: number | undefined): Promise<OrganizationJob> {
        let url_ = this.baseUrl + "/api/User/GetOrganizationJob?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationJob(_response);
        });
    }

    protected processGetOrganizationJob(response: Response): Promise<OrganizationJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationJob>(null as any);
    }

    post(user: User): Promise<User> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    put(user: User): Promise<User> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    delete(user: User): Promise<void> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteFromOrganization(user: User, organizationId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User/DeleteFromOrganization?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFromOrganization(_response);
        });
    }

    protected processDeleteFromOrganization(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInviteLink(email: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/User/GetInviteLink?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInviteLink(_response);
        });
    }

    protected processGetInviteLink(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    signUp(userDto: WebHookUserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User/SignUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignUp(_response);
        });
    }

    protected processSignUp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserInfo(userDto: WebHookUserDTO): Promise<WebHookUserDTO> {
        let url_ = this.baseUrl + "/api/User/GetUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: Response): Promise<WebHookUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebHookUserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebHookUserDTO>(null as any);
    }

    sendVerificationEmail(userDto: WebHookUserDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/User/SendVerificationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendVerificationEmail(_response);
        });
    }

    protected processSendVerificationEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export abstract class ModelBase implements IModelBase {
    id!: number;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted!: boolean;

    constructor(data?: IModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ModelBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IModelBase {
    id: number;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted: boolean;
}

export class DeviceCategory extends ModelBase implements IDeviceCategory {
    nameTranslationKey?: string | undefined;
    deviceModels?: DeviceModel[] | undefined;

    constructor(data?: IDeviceCategory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nameTranslationKey = _data["nameTranslationKey"];
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeviceCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameTranslationKey"] = this.nameTranslationKey;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeviceCategory extends IModelBase {
    nameTranslationKey?: string | undefined;
    deviceModels?: DeviceModel[] | undefined;
}

export class DeviceModel extends ModelBase implements IDeviceModel {
    modelCode?: string | undefined;
    devices?: Device[] | undefined;
    deviceCategoryId!: number;
    deviceCategory?: DeviceCategory | undefined;

    constructor(data?: IDeviceModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.modelCode = _data["modelCode"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            this.deviceCategoryId = _data["deviceCategoryId"];
            this.deviceCategory = _data["deviceCategory"] ? DeviceCategory.fromJS(_data["deviceCategory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelCode"] = this.modelCode;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : <any>undefined);
        }
        data["deviceCategoryId"] = this.deviceCategoryId;
        data["deviceCategory"] = this.deviceCategory ? this.deviceCategory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDeviceModel extends IModelBase {
    modelCode?: string | undefined;
    devices?: Device[] | undefined;
    deviceCategoryId: number;
    deviceCategory?: DeviceCategory | undefined;
}

export class Device extends ModelBase implements IDevice {
    connectId!: string;
    configured!: boolean;
    organizationId?: number | undefined;
    deviceModelId?: number | undefined;
    deviceModel?: DeviceModel | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    deviceState?: DeviceState | undefined;
    deviceConfig?: DeviceConfig | undefined;
    installedFirmwareVersion?: string | undefined;
    requestedFirmwareVersion?: string | undefined;

    constructor(data?: IDevice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectId = _data["connectId"];
            this.configured = _data["configured"];
            this.organizationId = _data["organizationId"];
            this.deviceModelId = _data["deviceModelId"];
            this.deviceModel = _data["deviceModel"] ? DeviceModel.fromJS(_data["deviceModel"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.deviceState = _data["deviceState"] ? DeviceState.fromJS(_data["deviceState"]) : <any>undefined;
            this.deviceConfig = _data["deviceConfig"] ? DeviceConfig.fromJS(_data["deviceConfig"]) : <any>undefined;
            this.installedFirmwareVersion = _data["installedFirmwareVersion"];
            this.requestedFirmwareVersion = _data["requestedFirmwareVersion"];
        }
    }

    static override fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectId"] = this.connectId;
        data["configured"] = this.configured;
        data["organizationId"] = this.organizationId;
        data["deviceModelId"] = this.deviceModelId;
        data["deviceModel"] = this.deviceModel ? this.deviceModel.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["deviceState"] = this.deviceState ? this.deviceState.toJSON() : <any>undefined;
        data["deviceConfig"] = this.deviceConfig ? this.deviceConfig.toJSON() : <any>undefined;
        data["installedFirmwareVersion"] = this.installedFirmwareVersion;
        data["requestedFirmwareVersion"] = this.requestedFirmwareVersion;
        super.toJSON(data);
        return data;
    }
}

export interface IDevice extends IModelBase {
    connectId: string;
    configured: boolean;
    organizationId?: number | undefined;
    deviceModelId?: number | undefined;
    deviceModel?: DeviceModel | undefined;
    locationId?: number | undefined;
    location?: Location | undefined;
    deviceState?: DeviceState | undefined;
    deviceConfig?: DeviceConfig | undefined;
    installedFirmwareVersion?: string | undefined;
    requestedFirmwareVersion?: string | undefined;
}

export class Location extends ModelBase implements ILocation {
    organizationId!: number;
    country!: string;
    zipCode!: string;
    street!: string;
    city!: string;
    floor!: string;
    room!: string;
    timeZoneId!: string;
    notificationSubscriptions?: NotificationSubscription[] | undefined;
    devices?: Device[] | undefined;

    constructor(data?: ILocation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.floor = _data["floor"];
            this.room = _data["room"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["notificationSubscriptions"])) {
                this.notificationSubscriptions = [] as any;
                for (let item of _data["notificationSubscriptions"])
                    this.notificationSubscriptions!.push(NotificationSubscription.fromJS(item));
            }
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["floor"] = this.floor;
        data["room"] = this.room;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.notificationSubscriptions)) {
            data["notificationSubscriptions"] = [];
            for (let item of this.notificationSubscriptions)
                data["notificationSubscriptions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILocation extends IModelBase {
    organizationId: number;
    country: string;
    zipCode: string;
    street: string;
    city: string;
    floor: string;
    room: string;
    timeZoneId: string;
    notificationSubscriptions?: NotificationSubscription[] | undefined;
    devices?: Device[] | undefined;
}

export class NotificationSubscription extends ModelBase implements INotificationSubscription {
    notifyEmail!: boolean;
    notifySms!: boolean;
    userId!: number;
    user?: User | undefined;
    locations?: Location[] | undefined;
    acute!: boolean;
    planned!: boolean;
    prolongedUseAlert!: boolean;
    overload!: boolean;
    impact!: boolean;
    maintenance!: boolean;
    reports!: boolean;

    constructor(data?: INotificationSubscription) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notifyEmail = _data["notifyEmail"];
            this.notifySms = _data["notifySms"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            this.acute = _data["acute"];
            this.planned = _data["planned"];
            this.prolongedUseAlert = _data["prolongedUseAlert"];
            this.overload = _data["overload"];
            this.impact = _data["impact"];
            this.maintenance = _data["maintenance"];
            this.reports = _data["reports"];
        }
    }

    static override fromJS(data: any): NotificationSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscription();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyEmail"] = this.notifyEmail;
        data["notifySms"] = this.notifySms;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["acute"] = this.acute;
        data["planned"] = this.planned;
        data["prolongedUseAlert"] = this.prolongedUseAlert;
        data["overload"] = this.overload;
        data["impact"] = this.impact;
        data["maintenance"] = this.maintenance;
        data["reports"] = this.reports;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationSubscription extends IModelBase {
    notifyEmail: boolean;
    notifySms: boolean;
    userId: number;
    user?: User | undefined;
    locations?: Location[] | undefined;
    acute: boolean;
    planned: boolean;
    prolongedUseAlert: boolean;
    overload: boolean;
    impact: boolean;
    maintenance: boolean;
    reports: boolean;
}

export class User extends ModelBase implements IUser {
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role!: UserRole;
    ignoreTutorial!: boolean;
    notificationSubscription?: NotificationSubscription | undefined;
    organizationUser?: OrganizationUser[] | undefined;

    constructor(data?: IUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.role = _data["role"];
            this.ignoreTutorial = _data["ignoreTutorial"];
            this.notificationSubscription = _data["notificationSubscription"] ? NotificationSubscription.fromJS(_data["notificationSubscription"]) : <any>undefined;
            if (Array.isArray(_data["organizationUser"])) {
                this.organizationUser = [] as any;
                for (let item of _data["organizationUser"])
                    this.organizationUser!.push(OrganizationUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["role"] = this.role;
        data["ignoreTutorial"] = this.ignoreTutorial;
        data["notificationSubscription"] = this.notificationSubscription ? this.notificationSubscription.toJSON() : <any>undefined;
        if (Array.isArray(this.organizationUser)) {
            data["organizationUser"] = [];
            for (let item of this.organizationUser)
                data["organizationUser"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IModelBase {
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role: UserRole;
    ignoreTutorial: boolean;
    notificationSubscription?: NotificationSubscription | undefined;
    organizationUser?: OrganizationUser[] | undefined;
}

export enum UserRole {
    GlobalAdmin = 0,
    User = 10,
}

export class OrganizationUser extends ModelBase implements IOrganizationUser {
    organizationRole!: OrganizationRole;
    organizationJob!: OrganizationJob;
    userId!: number;
    user?: User | undefined;
    organizationId!: number;
    organization?: Organization | undefined;

    constructor(data?: IOrganizationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationRole = _data["organizationRole"];
            this.organizationJob = _data["organizationJob"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrganizationUser {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationRole"] = this.organizationRole;
        data["organizationJob"] = this.organizationJob;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationUser extends IModelBase {
    organizationRole: OrganizationRole;
    organizationJob: OrganizationJob;
    userId: number;
    user?: User | undefined;
    organizationId: number;
    organization?: Organization | undefined;
}

export enum OrganizationRole {
    Admin = 10,
    Manager = 20,
    Maintenance = 30,
}

export enum OrganizationJob {
    Other = 0,
    Cleaning = 1,
    Janitorial = 2,
    Security = 3,
}

export class Organization extends ModelBase implements IOrganization {
    name?: string | undefined;
    description?: string | undefined;
    organizationUser?: OrganizationUser[] | undefined;

    constructor(data?: IOrganization) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["organizationUser"])) {
                this.organizationUser = [] as any;
                for (let item of _data["organizationUser"])
                    this.organizationUser!.push(OrganizationUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.organizationUser)) {
            data["organizationUser"] = [];
            for (let item of this.organizationUser)
                data["organizationUser"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrganization extends IModelBase {
    name?: string | undefined;
    description?: string | undefined;
    organizationUser?: OrganizationUser[] | undefined;
}

export class DeviceState extends ModelBase implements IDeviceState {
    deviceUses!: number;
    isConnected!: boolean;
    prolongedUseAlertOngoing!: boolean;
    prolongedUseAlertContinuedReceived!: number;
    deviceId!: number;
    lastDeviceUseTimestamp!: Date;

    constructor(data?: IDeviceState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceUses = _data["deviceUses"];
            this.isConnected = _data["isConnected"];
            this.prolongedUseAlertOngoing = _data["prolongedUseAlertOngoing"];
            this.prolongedUseAlertContinuedReceived = _data["prolongedUseAlertContinuedReceived"];
            this.deviceId = _data["deviceId"];
            this.lastDeviceUseTimestamp = _data["lastDeviceUseTimestamp"] ? new Date(_data["lastDeviceUseTimestamp"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): DeviceState {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceUses"] = this.deviceUses;
        data["isConnected"] = this.isConnected;
        data["prolongedUseAlertOngoing"] = this.prolongedUseAlertOngoing;
        data["prolongedUseAlertContinuedReceived"] = this.prolongedUseAlertContinuedReceived;
        data["deviceId"] = this.deviceId;
        data["lastDeviceUseTimestamp"] = this.lastDeviceUseTimestamp ? this.lastDeviceUseTimestamp.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDeviceState extends IModelBase {
    deviceUses: number;
    isConnected: boolean;
    prolongedUseAlertOngoing: boolean;
    prolongedUseAlertContinuedReceived: number;
    deviceId: number;
    lastDeviceUseTimestamp: Date;
}

export class DeviceConfig extends ModelBase implements IDeviceConfig {
    deviceId!: number;
    device?: Device | undefined;
    usagesBetweenCleaning!: number;
    prolongedUseAlertTimeoutMinutes!: number;
    prolongedUseAlertSound!: boolean;
    dailyReboot!: boolean;
    allowBackupFirmware!: boolean;
    backupFirmwareVersion?: string | undefined;

    constructor(data?: IDeviceConfig) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.device = _data["device"] ? Device.fromJS(_data["device"]) : <any>undefined;
            this.usagesBetweenCleaning = _data["usagesBetweenCleaning"];
            this.prolongedUseAlertTimeoutMinutes = _data["prolongedUseAlertTimeoutMinutes"];
            this.prolongedUseAlertSound = _data["prolongedUseAlertSound"];
            this.dailyReboot = _data["dailyReboot"];
            this.allowBackupFirmware = _data["allowBackupFirmware"];
            this.backupFirmwareVersion = _data["backupFirmwareVersion"];
        }
    }

    static override fromJS(data: any): DeviceConfig {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfig();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["usagesBetweenCleaning"] = this.usagesBetweenCleaning;
        data["prolongedUseAlertTimeoutMinutes"] = this.prolongedUseAlertTimeoutMinutes;
        data["prolongedUseAlertSound"] = this.prolongedUseAlertSound;
        data["dailyReboot"] = this.dailyReboot;
        data["allowBackupFirmware"] = this.allowBackupFirmware;
        data["backupFirmwareVersion"] = this.backupFirmwareVersion;
        super.toJSON(data);
        return data;
    }
}

export interface IDeviceConfig extends IModelBase {
    deviceId: number;
    device?: Device | undefined;
    usagesBetweenCleaning: number;
    prolongedUseAlertTimeoutMinutes: number;
    prolongedUseAlertSound: boolean;
    dailyReboot: boolean;
    allowBackupFirmware: boolean;
    backupFirmwareVersion?: string | undefined;
}

export class DeviceConfigDTO implements IDeviceConfigDTO {
    id?: number | undefined;
    deviceId?: number | undefined;
    usagesBetweenCleaning!: number;
    prolongedUseAlertTimeoutMinutes!: number;
    prolongedUseAlertSound!: boolean;
    dailyReboot!: boolean;
    allowBackupFirmware!: boolean;
    backupFirmwareVersion?: string | undefined;

    constructor(data?: IDeviceConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceId = _data["deviceId"];
            this.usagesBetweenCleaning = _data["usagesBetweenCleaning"];
            this.prolongedUseAlertTimeoutMinutes = _data["prolongedUseAlertTimeoutMinutes"];
            this.prolongedUseAlertSound = _data["prolongedUseAlertSound"];
            this.dailyReboot = _data["dailyReboot"];
            this.allowBackupFirmware = _data["allowBackupFirmware"];
            this.backupFirmwareVersion = _data["backupFirmwareVersion"];
        }
    }

    static fromJS(data: any): DeviceConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceId"] = this.deviceId;
        data["usagesBetweenCleaning"] = this.usagesBetweenCleaning;
        data["prolongedUseAlertTimeoutMinutes"] = this.prolongedUseAlertTimeoutMinutes;
        data["prolongedUseAlertSound"] = this.prolongedUseAlertSound;
        data["dailyReboot"] = this.dailyReboot;
        data["allowBackupFirmware"] = this.allowBackupFirmware;
        data["backupFirmwareVersion"] = this.backupFirmwareVersion;
        return data;
    }
}

export interface IDeviceConfigDTO {
    id?: number | undefined;
    deviceId?: number | undefined;
    usagesBetweenCleaning: number;
    prolongedUseAlertTimeoutMinutes: number;
    prolongedUseAlertSound: boolean;
    dailyReboot: boolean;
    allowBackupFirmware: boolean;
    backupFirmwareVersion?: string | undefined;
}

export class DeviceInfoDTO implements IDeviceInfoDTO {
    id!: number;
    connectId!: string;
    organizationId?: number | undefined;
    configured!: boolean;
    deviceModelCode?: string | undefined;
    deviceCategoryNameTranslationKey?: string | undefined;
    locationDTO?: LocationDTO | undefined;
    deviceConfig?: DeviceConfigDTO | undefined;
    deviceState?: DeviceState | undefined;
    deviceModelId?: number | undefined;
    locationId?: number | undefined;

    constructor(data?: IDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.connectId = _data["connectId"];
            this.organizationId = _data["organizationId"];
            this.configured = _data["configured"];
            this.deviceModelCode = _data["deviceModelCode"];
            this.deviceCategoryNameTranslationKey = _data["deviceCategoryNameTranslationKey"];
            this.locationDTO = _data["locationDTO"] ? LocationDTO.fromJS(_data["locationDTO"]) : <any>undefined;
            this.deviceConfig = _data["deviceConfig"] ? DeviceConfigDTO.fromJS(_data["deviceConfig"]) : <any>undefined;
            this.deviceState = _data["deviceState"] ? DeviceState.fromJS(_data["deviceState"]) : <any>undefined;
            this.deviceModelId = _data["deviceModelId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): DeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["connectId"] = this.connectId;
        data["organizationId"] = this.organizationId;
        data["configured"] = this.configured;
        data["deviceModelCode"] = this.deviceModelCode;
        data["deviceCategoryNameTranslationKey"] = this.deviceCategoryNameTranslationKey;
        data["locationDTO"] = this.locationDTO ? this.locationDTO.toJSON() : <any>undefined;
        data["deviceConfig"] = this.deviceConfig ? this.deviceConfig.toJSON() : <any>undefined;
        data["deviceState"] = this.deviceState ? this.deviceState.toJSON() : <any>undefined;
        data["deviceModelId"] = this.deviceModelId;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IDeviceInfoDTO {
    id: number;
    connectId: string;
    organizationId?: number | undefined;
    configured: boolean;
    deviceModelCode?: string | undefined;
    deviceCategoryNameTranslationKey?: string | undefined;
    locationDTO?: LocationDTO | undefined;
    deviceConfig?: DeviceConfigDTO | undefined;
    deviceState?: DeviceState | undefined;
    deviceModelId?: number | undefined;
    locationId?: number | undefined;
}

export class LocationDTO implements ILocationDTO {
    id!: number;
    organizationId!: number;
    country!: string;
    zipCode!: string;
    street!: string;
    city!: string;
    floor!: string;
    room!: string;
    timeZoneId?: string | undefined;
    notificationSubscriptionIds?: number[] | undefined;

    constructor(data?: ILocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.floor = _data["floor"];
            this.room = _data["room"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["notificationSubscriptionIds"])) {
                this.notificationSubscriptionIds = [] as any;
                for (let item of _data["notificationSubscriptionIds"])
                    this.notificationSubscriptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["floor"] = this.floor;
        data["room"] = this.room;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.notificationSubscriptionIds)) {
            data["notificationSubscriptionIds"] = [];
            for (let item of this.notificationSubscriptionIds)
                data["notificationSubscriptionIds"].push(item);
        }
        return data;
    }
}

export interface ILocationDTO {
    id: number;
    organizationId: number;
    country: string;
    zipCode: string;
    street: string;
    city: string;
    floor: string;
    room: string;
    timeZoneId?: string | undefined;
    notificationSubscriptionIds?: number[] | undefined;
}

export class DeviceTwinStateDTO implements IDeviceTwinStateDTO {
    extendedOverloadLogging!: boolean;
    extendedGeneralLogging!: boolean;

    constructor(data?: IDeviceTwinStateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extendedOverloadLogging = _data["extendedOverloadLogging"];
            this.extendedGeneralLogging = _data["extendedGeneralLogging"];
        }
    }

    static fromJS(data: any): DeviceTwinStateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTwinStateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extendedOverloadLogging"] = this.extendedOverloadLogging;
        data["extendedGeneralLogging"] = this.extendedGeneralLogging;
        return data;
    }
}

export interface IDeviceTwinStateDTO {
    extendedOverloadLogging: boolean;
    extendedGeneralLogging: boolean;
}

export class DeviceDataDumpDTO implements IDeviceDataDumpDTO {
    timeStamp?: Date | undefined;
    deviceBaseInfo?: DeviceBaseInfo | undefined;
    deviceBtInfo?: DeviceBTInfo | undefined;
    deviceModemInfo?: DeviceModemInfo | undefined;
    deviceSensorInfo?: DeviceSensorInfo | undefined;

    constructor(data?: IDeviceDataDumpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.deviceBaseInfo = _data["deviceBaseInfo"] ? DeviceBaseInfo.fromJS(_data["deviceBaseInfo"]) : <any>undefined;
            this.deviceBtInfo = _data["deviceBtInfo"] ? DeviceBTInfo.fromJS(_data["deviceBtInfo"]) : <any>undefined;
            this.deviceModemInfo = _data["deviceModemInfo"] ? DeviceModemInfo.fromJS(_data["deviceModemInfo"]) : <any>undefined;
            this.deviceSensorInfo = _data["deviceSensorInfo"] ? DeviceSensorInfo.fromJS(_data["deviceSensorInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceDataDumpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDataDumpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["deviceBaseInfo"] = this.deviceBaseInfo ? this.deviceBaseInfo.toJSON() : <any>undefined;
        data["deviceBtInfo"] = this.deviceBtInfo ? this.deviceBtInfo.toJSON() : <any>undefined;
        data["deviceModemInfo"] = this.deviceModemInfo ? this.deviceModemInfo.toJSON() : <any>undefined;
        data["deviceSensorInfo"] = this.deviceSensorInfo ? this.deviceSensorInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeviceDataDumpDTO {
    timeStamp?: Date | undefined;
    deviceBaseInfo?: DeviceBaseInfo | undefined;
    deviceBtInfo?: DeviceBTInfo | undefined;
    deviceModemInfo?: DeviceModemInfo | undefined;
    deviceSensorInfo?: DeviceSensorInfo | undefined;
}

export class DeviceBaseInfo implements IDeviceBaseInfo {
    uptimeS?: number | undefined;
    resetCause?: string | undefined;
    board?: string | undefined;
    fwVersion?: string | undefined;

    constructor(data?: IDeviceBaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uptimeS = _data["uptimeS"];
            this.resetCause = _data["resetCause"];
            this.board = _data["board"];
            this.fwVersion = _data["fwVersion"];
        }
    }

    static fromJS(data: any): DeviceBaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uptimeS"] = this.uptimeS;
        data["resetCause"] = this.resetCause;
        data["board"] = this.board;
        data["fwVersion"] = this.fwVersion;
        return data;
    }
}

export interface IDeviceBaseInfo {
    uptimeS?: number | undefined;
    resetCause?: string | undefined;
    board?: string | undefined;
    fwVersion?: string | undefined;
}

export class DeviceBTInfo implements IDeviceBTInfo {

    constructor(data?: IDeviceBTInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeviceBTInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBTInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeviceBTInfo {
}

export class DeviceModemInfo implements IDeviceModemInfo {
    online?: number | undefined;
    ccid?: string | undefined;
    ci?: number | undefined;
    fw?: string | undefined;
    rssi!: number;
    tac!: number;
    act!: number;

    constructor(data?: IDeviceModemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.online = _data["online"];
            this.ccid = _data["ccid"];
            this.ci = _data["ci"];
            this.fw = _data["fw"];
            this.rssi = _data["rssi"];
            this.tac = _data["tac"];
            this.act = _data["act"];
        }
    }

    static fromJS(data: any): DeviceModemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["online"] = this.online;
        data["ccid"] = this.ccid;
        data["ci"] = this.ci;
        data["fw"] = this.fw;
        data["rssi"] = this.rssi;
        data["tac"] = this.tac;
        data["act"] = this.act;
        return data;
    }
}

export interface IDeviceModemInfo {
    online?: number | undefined;
    ccid?: string | undefined;
    ci?: number | undefined;
    fw?: string | undefined;
    rssi: number;
    tac: number;
    act: number;
}

export class DeviceSensorInfo implements IDeviceSensorInfo {
    adcExternal1?: number | undefined;
    adcExternal2?: number | undefined;
    adcBattery?: number | undefined;
    adcRef?: number | undefined;
    adcBus?: number | undefined;

    constructor(data?: IDeviceSensorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adcExternal1 = _data["adcExternal1"];
            this.adcExternal2 = _data["adcExternal2"];
            this.adcBattery = _data["adcBattery"];
            this.adcRef = _data["adcRef"];
            this.adcBus = _data["adcBus"];
        }
    }

    static fromJS(data: any): DeviceSensorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSensorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adcExternal1"] = this.adcExternal1;
        data["adcExternal2"] = this.adcExternal2;
        data["adcBattery"] = this.adcBattery;
        data["adcRef"] = this.adcRef;
        data["adcBus"] = this.adcBus;
        return data;
    }
}

export interface IDeviceSensorInfo {
    adcExternal1?: number | undefined;
    adcExternal2?: number | undefined;
    adcBattery?: number | undefined;
    adcRef?: number | undefined;
    adcBus?: number | undefined;
}

export class Firmware extends ModelBase implements IFirmware {
    version!: string;
    filename!: string;

    constructor(data?: IFirmware) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.version = _data["version"];
            this.filename = _data["filename"];
        }
    }

    static override fromJS(data: any): Firmware {
        data = typeof data === 'object' ? data : {};
        let result = new Firmware();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["filename"] = this.filename;
        super.toJSON(data);
        return data;
    }
}

export interface IFirmware extends IModelBase {
    version: string;
    filename: string;
}

export class DeviceFirmwareDTO implements IDeviceFirmwareDTO {
    installedFirmwareVersion?: string | undefined;
    requestedFirmwareVersion?: string | undefined;

    constructor(data?: IDeviceFirmwareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installedFirmwareVersion = _data["installedFirmwareVersion"];
            this.requestedFirmwareVersion = _data["requestedFirmwareVersion"];
        }
    }

    static fromJS(data: any): DeviceFirmwareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceFirmwareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installedFirmwareVersion"] = this.installedFirmwareVersion;
        data["requestedFirmwareVersion"] = this.requestedFirmwareVersion;
        return data;
    }
}

export interface IDeviceFirmwareDTO {
    installedFirmwareVersion?: string | undefined;
    requestedFirmwareVersion?: string | undefined;
}

export class NotificationHistory extends ModelBase implements INotificationHistory {
    time!: Date;
    notificationType!: NotificationType;
    deviceUses!: number;
    deviceId!: number;
    device?: Device | undefined;
    notificationHistoryUsers?: NotificationHistoryUser[] | undefined;

    constructor(data?: INotificationHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.notificationType = _data["notificationType"];
            this.deviceUses = _data["deviceUses"];
            this.deviceId = _data["deviceId"];
            this.device = _data["device"] ? Device.fromJS(_data["device"]) : <any>undefined;
            if (Array.isArray(_data["notificationHistoryUsers"])) {
                this.notificationHistoryUsers = [] as any;
                for (let item of _data["notificationHistoryUsers"])
                    this.notificationHistoryUsers!.push(NotificationHistoryUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NotificationHistory {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["notificationType"] = this.notificationType;
        data["deviceUses"] = this.deviceUses;
        data["deviceId"] = this.deviceId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationHistoryUsers)) {
            data["notificationHistoryUsers"] = [];
            for (let item of this.notificationHistoryUsers)
                data["notificationHistoryUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotificationHistory extends IModelBase {
    time: Date;
    notificationType: NotificationType;
    deviceUses: number;
    deviceId: number;
    device?: Device | undefined;
    notificationHistoryUsers?: NotificationHistoryUser[] | undefined;
}

export enum NotificationType {
    Cleaning = 0,
    Impact = 1,
    Overload = 2,
    ProlongedUseAlertStarted = 3,
    ProlongedUseAlertContinuous = 4,
    ProlongedUseAlertEnd = 5,
    ProlongedUseAlertPrevented = 6,
}

export class NotificationHistoryUser extends ModelBase implements INotificationHistoryUser {
    userId!: number;
    user?: User | undefined;
    notificationHistoryId!: number;
    notificationHistory?: NotificationHistory | undefined;
    notifyEmail!: boolean;
    notifySms!: boolean;

    constructor(data?: INotificationHistoryUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.notificationHistoryId = _data["notificationHistoryId"];
            this.notificationHistory = _data["notificationHistory"] ? NotificationHistory.fromJS(_data["notificationHistory"]) : <any>undefined;
            this.notifyEmail = _data["notifyEmail"];
            this.notifySms = _data["notifySms"];
        }
    }

    static override fromJS(data: any): NotificationHistoryUser {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistoryUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["notificationHistoryId"] = this.notificationHistoryId;
        data["notificationHistory"] = this.notificationHistory ? this.notificationHistory.toJSON() : <any>undefined;
        data["notifyEmail"] = this.notifyEmail;
        data["notifySms"] = this.notifySms;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationHistoryUser extends IModelBase {
    userId: number;
    user?: User | undefined;
    notificationHistoryId: number;
    notificationHistory?: NotificationHistory | undefined;
    notifyEmail: boolean;
    notifySms: boolean;
}

export class NotificationSubscriptionDTO implements INotificationSubscriptionDTO {
    id!: number;
    notifyEmail!: boolean;
    notifySms!: boolean;
    userId!: number;
    locationIds?: number[] | undefined;
    acute!: boolean;
    planned!: boolean;
    prolongedUseAlert!: boolean;
    overload!: boolean;
    impact!: boolean;
    maintenance!: boolean;
    reports!: boolean;

    constructor(data?: INotificationSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notifyEmail = _data["notifyEmail"];
            this.notifySms = _data["notifySms"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.acute = _data["acute"];
            this.planned = _data["planned"];
            this.prolongedUseAlert = _data["prolongedUseAlert"];
            this.overload = _data["overload"];
            this.impact = _data["impact"];
            this.maintenance = _data["maintenance"];
            this.reports = _data["reports"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notifyEmail"] = this.notifyEmail;
        data["notifySms"] = this.notifySms;
        data["userId"] = this.userId;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["acute"] = this.acute;
        data["planned"] = this.planned;
        data["prolongedUseAlert"] = this.prolongedUseAlert;
        data["overload"] = this.overload;
        data["impact"] = this.impact;
        data["maintenance"] = this.maintenance;
        data["reports"] = this.reports;
        return data;
    }
}

export interface INotificationSubscriptionDTO {
    id: number;
    notifyEmail: boolean;
    notifySms: boolean;
    userId: number;
    locationIds?: number[] | undefined;
    acute: boolean;
    planned: boolean;
    prolongedUseAlert: boolean;
    overload: boolean;
    impact: boolean;
    maintenance: boolean;
    reports: boolean;
}

export class TimeZoneDTO implements ITimeZoneDTO {
    timeZoneId?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ITimeZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TimeZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITimeZoneDTO {
    timeZoneId?: string | undefined;
    displayName?: string | undefined;
}

export class WebHookUserDTO implements IWebHookUserDTO {
    email?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    extension_Role?: string | undefined;
    otp?: string | undefined;

    constructor(data?: IWebHookUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.extension_Role = _data["extension_Role"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): WebHookUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["extension_Role"] = this.extension_Role;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IWebHookUserDTO {
    email?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    extension_Role?: string | undefined;
    otp?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// This class is copied to api.ts when running codegen.